module.exports = __webpack_public_path__ + "img/ponte-nord_est.d6d0f3ae.png";